/**
 * List Tag Rule fields - shared between frontend and backend.
 * Matches SMSWiser/Voluum list stats columns.
 * For Media Devoted | Created By Ciro Autiero
 */

export const LIST_TAG_RULE_FIELDS = [
  'impressions',
  'ImCTR',
  'uniqueVisits',
  'uniqueClicks',
  'uCTR',
  'Click2Reg',
  'conversions',
  'Reg2Dep',
  'customConversions6', // REG
  'revenue',
  'customConversions7', // FTD
  'cost',
  'profit',
  'roi',
  'uEPC',
  'uEPV',
  'epv',
  'epc',
  'epl',  // Earnings per lead (revenue / REG)
  'CPuC', // Cost per unique click
  'CPL',  // Cost per lead (REG)
  'CPS',  // Cost per SMS (impression)
] as const;

/** Emojis a drop tag rule can display instead of / next to its name. */
export const TAG_RULE_EMOJIS = ['+', '-'] as const;

/** System list tags a DROP rule can gate on: the rule then applies only to
 *  drops whose list currently carries one of the selected tags (per the
 *  system tags configuration — new-days window, unused-since cohort). */
export const DROP_RULE_LIST_SYSTEM_TAGS = ['New', 'Unused'] as const;
export type DropRuleListSystemTag =
  (typeof DROP_RULE_LIST_SYSTEM_TAGS)[number];

/** Prefix marking a condition field as reading the drop's SOURCE metrics. */
export const DROP_SOURCE_FIELD_PREFIX = 'source_';

/** Prefix marking a condition field as reading the drop's LIST metrics. */
export const DROP_LIST_FIELD_PREFIX = 'list_';

/**
 * Drop-rule-only fields: metrics of the LIST the drop was sent to (its CV4),
 * aggregated over the rule's date range — e.g. "+" when list_roi >= 100.
 */
export const DROP_LIST_TAG_RULE_FIELDS = [
  'list_profit',
  'list_roi',
  'list_revenue',
  'list_cost',
  'list_uniqueVisits',
  'list_customConversions7', // List FTD
  'list_epl', // List earnings per lead
] as const;

/**
 * Drop-rule-only fields: metrics of the drop's top traffic source (the CV5 /
 * token_5 with the most unique visits in the drop's traffic). Conditions read
 * the source's OWN aggregate for the rule's date range, e.g. "+" when
 * source_roi >= 100.
 */
export const DROP_SOURCE_TAG_RULE_FIELDS = [
  'source_profit',
  'source_roi',
  'source_revenue',
  'source_cost',
  'source_uniqueVisits',
  'source_customConversions7', // Source FTD
  'source_epl', // Source earnings per lead
] as const;

export type ListTagRuleField = (typeof LIST_TAG_RULE_FIELDS)[number];

export const LIST_TAG_RULE_FIELD_LABELS: Record<ListTagRuleField, string> = {
  impressions: 'Impressions',
  ImCTR: 'SMS CTR',
  uniqueVisits: 'Unique visits',
  uniqueClicks: 'Unique clicks',
  uCTR: 'uCTR',
  Click2Reg: 'Click2Reg',
  conversions: 'Conversions',
  Reg2Dep: 'Reg2Dep',
  customConversions6: 'REG',
  revenue: 'Revenue',
  customConversions7: 'FTD',
  cost: 'Cost',
  profit: 'Profit',
  roi: 'ROI',
  uEPC: 'uEPC',
  uEPV: 'uEPV',
  epv: 'EPV',
  epc: 'EPC',
  epl: 'EPL',
  CPuC: 'CPuC',
  CPL: 'CPL',
  CPS: 'CPS',
};
